import React from 'react';


export const OptionActiveIcon = props => {
    return (
        <svg className={props.className} width="30" height="30" viewBox="0 0 30 30" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="26" height="26" rx="6" fill="#7EB092" stroke="#D9E8FF" strokeWidth="4"/>
        </svg>
    )
};
